<template>
  <div class="wrapper">
    <div class="image-section">
      <img
        src="@/assets/about/3.jpg"
        alt=""
      >
      <img
        src="@/assets/about/2.jpg"
        alt=""
      >
      <img
        src="@/assets/about/1.jpg"
        alt=""
      >
    </div>
    <div class="header-section">
      <h5>SPLENDOR CREW</h5>
    </div>
    <div class="text-section">
      <p>
        Dla każdego z nas istnieją rzeczy, które po prostu dają nam radość.
        Marka SPLENDOR powstała, aby podkreślać jak ważne jest posiadanie
        i pielęgnowanie własnej zajawki.
        <br><br>
        Wywodząca się z deskorolki chęć przekraczania własnych granic skłoniła Nas do konkretnych działań,
        mających na celu zaszczepienie wśród społeczeństwa chęci poszukiwania dziecięcej radości póki słońce jeszcze nad nami świeci.
        <br><br>
        Dla jednych może to być taniec,
        dla innych jazda na desce, czy nartach, a jeszcze inni mają zajawę na grafiti.
        Ważne jest jednak to, aby odnaleźć swój własny SPLENDOR.
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'About'
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100%;
  width: 100%;
  padding: 10px;
  padding-top: 80px;
  color: #000000;
}
.header-section {
  margin-bottom: 20px;
  letter-spacing: 3px;
  font-weight: bold;
}

.text-section {
  text-align: justify;
}
.image-section {
  margin-bottom: 100px;
  margin-top: 50px;
}
.image-section img {
  width: 100%;
}

@media (min-width: 992px) {
  .wrapper {
    // padding-top: 130px;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding: 0;
  }
  .text-section {
    font-size: 1.2rem;
    letter-spacing: 1.5px;
    padding: 50px;
  }
  .header-section {
    margin-bottom: 80px;
    letter-spacing: 4px;
  }
  .header-section h5 {
    font-size: 2rem;
  }
  .image-section {
    margin-top: 0px;
    margin-bottom: 100px;
    width: 100%;
  }
  .image-section img {
    width: 33%;
  }
}
</style>
